import { Button, Container, Stack, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC, ReactNode, useEffect, useState } from 'react';
import GetRecord from '../../../lib/api/GetRecord';
import POPULATION from '../../../lib/api/Populations.json';
import { APIS } from '../../../lib/constants/apis';
import { getFieldNamefromDataPath, removeDataKeys, removeNullDeep } from '../../../utils/helper';

import AddIcon from '@mui/icons-material/Add';
import { useLocation } from 'react-router-dom';
import theme from '../../../assets/theme/theme';
import LoadingBackdrop from '../../../components/ui-component/loading/LoadingBackdrop';
import NoDetailsInfo from '../../../components/ui-component/no-details-info/NoDetailsInfo';
import { PAGES_URLS } from '../../../lib/constants/routes';
import FoerderAntragUebersicht from './FoerderAntragUebersicht/FoerderAntragUebersicht';

// import Schema
import GetRecords from '../../../lib/api/GetRecords';
import Schema from '../../../lib/paths/antrag_FOERDERUNG_UEBERSICHT_SEITE_Paths.json';
import SchuljahrSchema from '../../../lib/paths/schluljahr_FULL_Paths.json';
const P = Schema.attributes;
const SJ_P = SchuljahrSchema.attributes;

function FoerderungUebersicht() {
	// const navigate = useNavigate();
	const location = useLocation();
	const numericId = get(location, 'state.id');

	const [applicationData, setApplicationData] = useState({});
	const [loading, setLoading] = useState<boolean>(false);
	const [schulJahr, setSchulJahr] = useState({});

	const RenderDashboard = () => {
		return <FoerderAntragUebersicht application={applicationData} schulJahr={schulJahr} />;
	};

	useEffect(() => {
		const fetch = async () => {
			setLoading(true);
			try {
				let res = await GetRecord(APIS.Antrag, numericId, POPULATION.antrag.FOERDERUNG_UEBERSICHT_SEITE);
				setApplicationData(removeNullDeep(removeDataKeys(get(res, 'data', {}))));

				const filter = {
					[getFieldNamefromDataPath(SJ_P.Jahr.path)]: new Date().getFullYear(),
				};
				const schulRes = await GetRecords(APIS.SchulJahr, POPULATION.schluljahr.FULL, filter);
				if (schulRes) {
					const allschulJahre = removeNullDeep(removeDataKeys(get(schulRes, 'data', [])));
					setSchulJahr(allschulJahre[0]);
				}
			} catch (err: any) {
				console.error('ERROR: Fetching Application ', err);
			} finally {
				setLoading(false);
			}
		};
		if (numericId) fetch();
	}, [numericId]);

	if (!numericId) return <NoDetailsInfo title='Antrag' goBackUrl={PAGES_URLS.MeineFoerderung} />;

	if (loading) return <LoadingBackdrop open={loading} />;

	return (
		<>
			<Container>
				<Stack spacing={3} className='buit-dashboard'>
					<span>
						<Typography variant='h3' component='h2'>
							Meine Förderung: {get(applicationData, P.Zusammenfassung_Ueberblick_Titel.path, '')}
						</Typography>
					</span>

					<RenderDashboard />
				</Stack>
			</Container>
		</>
	);
}

export default FoerderungUebersicht;

type AntragButtonProps = {
	name: string;
	description: string;
	onClick: () => void;
	variant?: 'text' | 'outlined' | 'contained';
	disabled?: boolean;
};
export const AntragButton: FC<AntragButtonProps> = ({ name, description, onClick, disabled, variant = 'outlined' }) => {
	return (
		<>
			<Button
				disabled={disabled}
				variant={'outlined'}
				onClick={() => onClick()}
				sx={{
					borderRadius: 0,
					borderColor: theme.palette.border.primary,
					backgroundColor: disabled ? theme.palette.action.disabled : '#fff',
					color: disabled ? theme.palette.text.disabled : theme.palette.primary.main,
					textAlign: 'left',
					width: '26.5rem',
					justifyContent: 'space-between',
					padding: '1rem 1rem',
					marginTop: '0.5rem !important',
					maxWidth: 'unset',
				}}
				endIcon={variant === 'contained' ? <AddIcon sx={{ fontSize: '2.5rem !important' }} /> : null}
			>
				<Stack>
					<Typography variant='h5' sx={{ fontWeight: 400 }}>
						{name}
					</Typography>
					<Typography variant='body2'>{description}</Typography>
				</Stack>
			</Button>
		</>
	);
};

type AntragsButtonWrapperType = {
	title: string;
	children: ReactNode;
};
export const AntragsButtonWrapper: FC<AntragsButtonWrapperType> = ({ title, children }) => {
	return (
		<Stack spacing={0} sx={{ mt: '1rem' }}>
			<Typography variant='h6'>{title}</Typography>
			<Stack direction={'column'} columnGap={5}>
				{children}
			</Stack>
		</Stack>
	);
};
